import { render, staticRenderFns } from "./TabStaffCommission.vue?vue&type=template&id=0ae6891e"
import script from "./TabStaffCommission.vue?vue&type=script&lang=js"
export * from "./TabStaffCommission.vue?vue&type=script&lang=js"
import style0 from "./TabStaffCommission.vue?vue&type=style&index=0&id=0ae6891e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports